<template>
  <div class="container">
    <!-- 常见问题 -->

    <div class="inner_center">

      <h2 class="problem">常见问题</h2>

      <div class="problem-list">
        <div class="problem-item">
          <div class="problem-title">
            01、支持开具发票吗？要怎么开？
          </div>
          <div class="problem-content">
            购买潮国创意任意VIP会员，均可支持申请开具发票。我们将提供电子发票形式的增值税普通发票，可前往【个人中心-VIP会员】，点击【申请发票】即可。
          </div>
        </div>

        <div class="problem-item">
          <div class="problem-title">
            02、购买VIP会员后是否可以退款？
          </div>
          <div class="problem-content">
            潮国创意提供的VIP会员付费服务属于虚拟产品，请您买前仔细阅读《VIP服务协议》，非故障情况，一经生效后不可转让、退订、退款。
          </div>
        </div>

        <div class="problem-item">
          <div class="problem-title">
            03、在哪查看VIP会员到期时间？
          </div>
          <div class="problem-content">
            1、鼠标移至顶部头像，出现下拉展示即可看到 <br>
            2、点击顶部头像，进入个人中心也可查看
          </div>
        </div>

        <div class="problem-item">
          <div class="problem-title">
            04、如有其他问题，请咨询在线客服
          </div>
          <div class="problem-content">
            我还有问题：<a :href="SERVICE_LINK" target="_blank" class="service">咨询在线客服</a>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {SERVICE_LINK} from "@/constant/_Public/Path"
export default {
  name: "IntroduceQuestion",
  data(){
    return{
      SERVICE_LINK
    }
  }
}
</script>

<style lang="scss" scoped>
.container {

  .inner_center {
    width: 1200px !important;
  }

  h2 {
    font-size: 36px;
    font-weight: bold;
    color: #2D2B33;
    line-height: 48px;
    letter-spacing: 1px;
    text-align: center;
  }

  .problem-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 64px;

    .problem-item {
      width: 540px;
      margin-bottom: 40px;
      margin-right: 120px;

      &:nth-child(2n) {
        margin-right: 0;
      }

      .problem-title {
        font-size: 20px;
        font-weight: bold;
        color: #0A2540;
        line-height: 27px;
        letter-spacing: 1px;
        margin-bottom: 16px;
      }

      .problem-content {
        font-size: 14px;
        color: #596088;
        line-height: 24px;

        .service {
          font-size: 14px;
          color: #6969FF;
          line-height: 24px;
          text-decoration: underline;
        }
      }
    }

  }
}
</style>
